/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForDimensionGraphDBSyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForDimensionGraphDBSyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForDimensionGraphDBSyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForDimensionGraphDBSyncAdhoc>): BackgroundJobPayloadForDimensionGraphDBSyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForDimensionGraphDBSyncAdhoc(), model);
        BackgroundJobPayloadForDimensionGraphDBSyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForDimensionGraphDBSyncAdhoc>): BackgroundJobPayloadForDimensionGraphDBSyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForDimensionGraphDBSyncAdhoc.newInstance(<BackgroundJobPayloadForDimensionGraphDBSyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForDimensionGraphDBSyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForDimensionGraphDBSyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForDimensionGraphDBSyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForDimensionGraphDBSyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
